<template>
	<div class="signle-wrapper">
		<top :pagetitle="$t('登录')"></top>
		<div class="signle-main">
			<div class="form-panel">
				<div class="form-in">
					<div class="form-logo"><img :src="$helper.get('rule').app_logo" alt="" /></div>
					<!-- Nav tabs -->
					<el-tabs v-model="activeName" class="el-skin-tabs">
						<el-tab-pane :label="$t('账号登录')" name="first">
							<el-form ref="form" :model="form">
								<el-form-item>
									<el-input v-model="form.account" :placeholder="$t('请输入账户/手机/邮箱')"></el-input>
								</el-form-item>
								<el-form-item>
									<el-input type="password" show-password v-model="form.password" :placeholder="$t('请输入登录密码')" ></el-input>
								</el-form-item>
								<el-form-item>
									<el-checkbox v-model="form.checked">
										{{$t('记住密码')}}
									</el-checkbox>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" round :loading="LoginLoading" @click="onSubmit">
										{{$t('登录')}}
									</el-button>
								</el-form-item>
							</el-form>
						</el-tab-pane>
						<!-- <el-tab-pane label="短信登录" name="second">
							<el-form ref="form" :model="form">
								<el-form-item>
									<el-input v-model="form.phone" placeholder="请输入手机"></el-input>
								</el-form-item>
								<el-form-item>
									<div class="input-row flex">
										<div class="flex-col">
											<el-input v-model="form.code" placeholder="请输入登录密码"></el-input>
										</div>
										<el-button class="btn-getCode" type="warning">发送</el-button>
									</div>
								</el-form-item>
								<el-form-item>
									<el-checkbox v-model="form.checked">记住密码</el-checkbox>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" round :loading="LoginLoading" @click="onSubmit">登录</el-button>
								</el-form-item>
							</el-form>
						</el-tab-pane> -->
					</el-tabs>
					<div class="form-links">
						<router-link to="/register" class="link-item">{{$t('注册新用户')}}</router-link>
						<router-link to="/reset-password" class="link-item">{{$t('忘记密码')}}?</router-link>
					</div>
					<!-- <div class="form-share">
						<a href="" class="form-share-link">
							<span class="iconfont icon-facebook"></span>
						</a>
						<a href="" class="form-share-link">
							<span class="iconfont icon-telegram"></span>
						</a>
						<a href="" class="form-share-link">
							<span class="iconfont icon-insgram"></span>
						</a>
					</div> -->
				</div>
			</div>
		</div>
		<bottom></bottom>
	</div>
</template>
<script>
import helper from '@/common/helper.js';
import top from '@/components/top';
import bottom from '@/components/bottom';
import { login_doLogin_api } from '@/api/login'
export default {
	components:{
		bottom,top
	},
	data() {
		return {
			LoginLoading:false,
			spRules: {},
			activeName: 'first',
			form: {
				account: '',
				password: '',
				checked: false,
				code: '',
				verify_type: ""
			}
		};
	},
	methods: {
		async onSubmit() {
			if (this.form.account == "") {
				this.errorTips("请输入用户名");
				return false;
			}
			if (this.form.password == "") {
				this.errorTips("请输入密码");
				return false;
			}
			const data = {
				account: this.form.account,
				password: this.form.password,
			}
			const loading = this.$loading({
			  lock: true,
			  text: '',
			  spinner: 'loader',
			  background: 'rgba(255, 255, 255, 0.3)'
			});
			this.LoginLoading = true
			await login_doLogin_api(data).then(res => {
				if (res && res.data.code == 1) {
					this.updateUserInfo();
					const expirationTime = Date.now() + 8 * 60 * 60 * 1000;
					
					this.$helper.set("expirationTime", expirationTime);
					this.$helper.set("tokenInfo", res.data.data);
					
					this.$store.commit("$vuexSetUserTokenState", res.data.data.token);
					this.$store.commit(
						"$vuexSetUserTokenKeyState",
						res.data.data.token_key
					);
					this.$store.commit("$vuexSetLoginState", true);
					this.$message({
						customClass: "successMessage",
						showClose: false,
						message: this.$t("登录成功"),
						center: true,
						type: "success",
						duration: "1000"
					});
					loading.close()
					this.saveCredentials();
					this.getCredentials();
					this.$router.push("/")
					window.location.reload();
				} else {
					this.errorTips(res.data.msg, {
						showClose: false,
						duration: "2000",
						onClose: () => {
						}
					});
					loading.close()
				}
				this.LoginLoading = false;
			});
		},
		// 保存凭据的方法
		saveCredentials() {
		    const now = new Date().getTime(); // 获取当前时间戳
		    if (this.form.checked) {
		        this.$helper.set('savedUsername', this.form.account);
		        this.$helper.set('savedPassword', this.form.password);
		        this.$helper.set('credentialsTimestamp', now); // 保存当前时间戳
		    } else {
		        // 如果没有勾选，清除之前保存的用户名和密码
		        this.$helper.rm('savedUsername');
		        this.$helper.rm('savedPassword');
		        this.$helper.rm('credentialsTimestamp'); // 也清除时间戳
		    }
		},
		// 获取凭据的方法
		getCredentials() {
		    const savedUsername = this.$helper.get('savedUsername');
		    const savedPassword = this.$helper.get('savedPassword');
		    const timestamp = this.$helper.get('credentialsTimestamp');
		    if (savedUsername && savedPassword && timestamp) {
		        const now = new Date().getTime();
		        const hoursPassed = (now - timestamp) / (1000 * 60 * 60); 
		
		        if (hoursPassed < 12) {
		            return { username: savedUsername, password: savedPassword }; // 返回有效的用户名和密码
		        } else {
		            // 超过 12 小时，清除存储
		            this.$helper.rm('savedUsername');
		            this.$helper.rm('savedPassword');
		            this.$helper.rm('credentialsTimestamp');
		            return null; // 返回 null，表示无效
		        }
		    }
		    return null; 
		},
		// 获取手机验证码
		async sendPhoneCode() {},
		sendEmailCode() {},
		// 发送邮箱验证码
		async getMailCode() {},
	},
	mounted() {
		this.spRules = this.$helper.get('rule');
		const savedUsername = this.$helper.get('savedUsername');
		const savedPassword = this.$helper.get('savedPassword');
		if (savedUsername) {
		  this.form.account = savedUsername;
		}
		if (savedPassword) {
		  this.form.password = savedPassword;
		}
	}
}
</script>
<style scoped>
@import url("../assets/css/signle.css");
</style>